
{
  "hero": {
    "title": "尋找香港值得信賴的服務提供者",
    "subtitle": "與經過驗證的專業人士聯繫，滿足您的家庭和商業需求",
    "cta": "開始使用",
    "searchPlaceholder": "您在尋找什麼服務？"
  },
  "howItWorks": {
    "title": "如何運作",
    "step1": {
      "title": "搜尋",
      "description": "瀏覽我們經過驗證的服務提供者目錄"
    },
    "step2": {
      "title": "聯繫",
      "description": "通過WhatsApp直接聯繫服務提供者"
    },
    "step3": {
      "title": "評價",
      "description": "留下回饋幫助他人做出明智決定"
    }
  },
  "categories": {
    "title": "熱門類別",
    "viewAll": "查看所有類別"
  },
  "featured": {
    "title": "精選服務提供者",
    "viewAll": "查看所有服務提供者"
  },
  "cta": {
    "provider": {
      "title": "準備好發展您的業務了嗎？",
      "subtitle": "加入已在我們平台上的數千名服務提供者",
      "button": "列出您的服務"
    }
  },
  "providerCta": {
    "title": "準備好發展您的業務了嗎？",
    "description": "加入已在我們平台上的數千名服務提供者",
    "listServiceFree": "列出您的服務 - 免費",
    "upgradePremium": "升級至高級版",
    "addNewListing": "新增列表"
  }
}
